import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../../scss/components/pages/signTime.scss';
import axios from 'axios';
import Select from 'react-select'
import API from '../../../middleware/API';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import swal from 'sweetalert2';
import Slider from 'react-slick';

import Pagination from '../../Pagination';
import FillLeave from '../../FillLeave'
import { lowerFirst } from 'lodash';

class LeaveList extends Component {
  constructor(props) {
    super(props);
    let start = moment().add(0, 'month').format('YYYY-MM') + '-01';
    let end = moment(start).add(1, 'month').add(-1, 'days').format('YYYY-MM-DD');
    this.state = {
      start: moment().add(0, 'month').format('YYYY-MM') + '-01',
      end: moment(start).add(1, 'month').add(-1, 'days').format('YYYY-MM-DD'),
      editTargetDate: moment().format('YYYY-MM-DD'),
      leaveTypeId: '-1',
      leaveStatus: '',
      editTargetId:0,
      currPage: 1,
      countOfPage: 5,
      searchStartDate: moment(start),
      searchEndDate: moment(end),
      isAddWorkTimeOpen: false,
      longLeave: false,
      isPartTime: false,
      remainHours: 0,
      compensatoryHours:0,
      signingCompensatoryHours:0,
      signingAnnualHours:0,
      requestType:'ADD',
      leaveRecList: [],
      leaveTypeList: [],
      employees:[],
      editTarget:{
          sDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
          eDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
          leaveItemId: 0,
          agentUserId: 0,
          leaveHours: 0,
          reasons: '',
          notes: '',
          fileName: '',
      }
    }
    this.handleSearchStartDateChange = this.handleSearchStartDateChange.bind(this);
    this.handleSearchEndDateChange = this.handleSearchEndDateChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSearchButton = this.handleSearchButton.bind(this);
    this.cutTimeFunc = this.cutTimeFunc.bind(this);
    this.handleToggleOpenAddWorkTimeBlock = this.handleToggleOpenAddWorkTimeBlock.bind(this);
    this.handleAddStaffWorkRecord = this.handleAddStaffWorkRecord.bind(this);
    this.handleOnChangeLeaveRecInput = this.handleOnChangeLeaveRecInput.bind(this);
    this.resetEditTarget = this.resetEditTarget.bind(this);
  }
  loadRecList(){
    const m = this;

    let {currPage, countOfPage, leaveTypeId, leaveStatus} = this.state;
    // m.setState({
    //   remainHours: 0,
    //   compensatoryHours:0,
    //   signingCompensatoryHours:0,
    //   signingAnnualHours:0,
    //   totalPage:0,
    //   leaveRecList: [],
    // }, () => {
    API.get('LeaveRec?status='+leaveStatus+'&type='+leaveTypeId).then((response) => {
        if (response) {
          const res = response.recList;
          res.sort(function(a, b){return b.id - a.id});                  
          this.setState({
            isPartTime: response.isPartTime,
            remainHours: response.remainHours,
            compensatoryHours: response.compensatoryHours,
            signingCompensatoryHours: response.signingCompensatoryHours,
            signingAnnualHours: response.signingAnnualHours,
            totalPage: Math.ceil(res.length / countOfPage),
            leaveRecList: res.slice((currPage - 1) * countOfPage, ((currPage - 1) * countOfPage) + countOfPage),
            
          });
        }
      })
    //});
  }

  resetEditTarget(){
    let emptyTarget = {
        sDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
        eDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
        leaveItemId: 0,
        agentUserId: 0,
        leaveHours: 0,
        reasons: '',
        notes: '',
        fileName: '',
    }

    this.setState({
        editTarget:emptyTarget       
      });
  }

  componentDidMount() {
    API.get('Leave').then((res) => {
      if (res) {        
        this.setState({
          leaveTypeList: res,
        }, this.loadRecList());
      }
    }); 
    API.get('User/SameGroup').then((res) => {
      if (res) {
        this.setState({
          employees: res
        })
      }
    });
  }
  diff = (start, end) => {
    start = start.split(":");
    end = end.split(":");
    let startDate = new Date(0, 0, 0, start[0], start[1], 0);
    let endDate = new Date(0, 0, 0, end[0], end[1], 0);
    let diff = endDate.getTime() - startDate.getTime();
    let hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    let minutes = Math.floor(diff / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours
    if (hours < 0)
       hours = hours + 24;

    if(hours + (minutes/60) > 8){
      return 8;
    }    
    return hours + (minutes/60);
  }
  handleOnChangeLeaveRecInput(key, e) {
    let newObj = Object.assign(this.state.editTarget);
    if(moment.isMoment(e)){
      newObj[key] = e;
    }else if(key === 'reasons'){
      newObj[key] = e.target.value;
    }else if(key === 'setDate'){        
      newObj['sDate'] = e + 'T' + newObj['sDate'].split('T')[1];
      newObj['eDate'] = e + 'T' + newObj['eDate'].split('T')[1];
    }else if(key === 'workingHours'){
      newObj[key] = parseFloat(e.target.value, 10);
    }else if(typeof e === 'string'){
      newObj[key] = e;
    }else{
      newObj[key] = parseInt(e.target.value, 10);
    }

    if(key === 'eDate' || key === 'sDate'){
      newObj['leaveHours'] = this.diff(newObj['sDate'].split('T')[1] ,newObj['eDate'].split('T')[1] )
    }

    this.setState({
        editTarget: newObj
    });
  }
  handleLeaveTypeChange(leaveitemId) {        
    console.log(leaveitemId)
  }
  handleToggleOpenAddWorkTimeBlock(targetDate, targetId, requestType) {        
    if(this.state.isAddWorkTimeOpen){
        this.resetEditTarget();
    }

    if(targetId !== -1){
        this.setState({
            editTarget: this.state.leaveRecList.find(leaveRec => leaveRec.id === targetId),
            editTargetId: targetId,
            isAddWorkTimeOpen: !this.state.isAddWorkTimeOpen,
            requestType: requestType
          });
    }else{

        let emptyTarget = {
            sDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
            eDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
            leaveItemId: 0,
            agentUserId: 0,
            leaveHours:0,
            reasons: '',
            notes: '',
            fileName: '',
        }
        
        this.setState({
            editTarget: emptyTarget,
            editTargetDate: targetDate,
            editTargetId: targetId,
            isAddWorkTimeOpen: !this.state.isAddWorkTimeOpen,
            requestType: requestType
          });
    }

  }
  handleAddStaffWorkRecord(data) {

    let {id, leaveItemId, sDate, eDate, agentUserId, reasons, leaveHours} = this.state.editTarget;
    let {requestType} = this.state;
    let request = {
        id: id,
        leaveItemId: leaveItemId,
        sDate: sDate,
        eDate: eDate,
        agentUserId: agentUserId,
        reasons: reasons,
        leaveHours: leaveHours,
        status: 'S'
    }
    if(data){
      var formData = new FormData();
      formData.append("PicFile", data);
      axios.post('https://wisdombank.liangshishu.com/member/api/FileUploader/CafeLeavePic', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        if(res.data.indexOf('Error') !== -1)
        {
          swal({type:'error',title:'檔案上傳失敗，請重新再試'});
          return;
        }
        request.fileName = res.data.split('/')[res.data.split('/').length-1];

        if (requestType === 'ADD'){
            API.post('LeaveRec', request).then((response) => {
              console.log(response)
                if (response == 1) {
                    this.resetEditTarget();
                    this.loadRecList()
                }else{
                  swal({type:'error',title:'該時段已有其他假單'})
                }
              });
        }else{
            API.put('LeaveRec/'+request.id, request).then((response) => {
                if (response == 1 ) {
                    this.resetEditTarget();
                    this.loadRecList()
                }
              });
        }

      });
    }else{
        if (requestType === 'ADD'){
            API.post('LeaveRec', request).then((response) => {
                            console.log(response)

                if (response == 1) {
                    this.resetEditTarget();
                    this.loadRecList()
                }else{
                  swal({type:'error',title:'該時段已有其他假單'})
                }
              });
        }else{
            API.put('LeaveRec/'+request.id, request).then((response) => {
                if (response == 1) {
                    this.resetEditTarget();
                    this.loadRecList()
                }
              });
        }
    }
    
  }


  handleSearchStartDateChange(date) {
    this.setState({
      searchStartDate: date
    })
  }

  handleSearchEndDateChange(date) {
    this.setState({
      searchEndDate: date
    })
  }

  handleChangePage(page) {
    
    this.setState({
      currPage: page
    }, () => this.loadRecList())
  }

  handleSearchButton() {

  }

  cutTimeFunc(date) {
    if (date) return date.split('T')[0] + ' ' + date.split('T')[1].substring(0, 8);
    return date;
  }

  render() {
    let { leaveRecList, leaveTypeList, leaveTypeId, leaveStatus } = this.state;
    let newRecords = [];
    const settings = {
      dots: true,
      arrows: false,
      responsive: [
        { settings: { slickGoTo: 0, initialSlide: 0 } }
      ]
    };
    // leaveRecList.forEach((item) => {
    //   let newItem = {
    //     id: item.id,
    //     applyDate: item.applyDate,
    //     sDate: item.sDate,
    //     eDate: item.eDate,
    //     statusString: item.statusString,
    //   }
    //   newRecords.push(newItem);
    // });

    let pageControl = '';
    
    if (leaveRecList.length > 0){
       
        pageControl = <Pagination 
            currPage={this.state.currPage} totalPage={this.state.totalPage}
            onChangPage={this.handleChangePage}
        />
    }
  

    const slides = leaveRecList.map((item, index) => (
      <div key={index}>
      <table className="u-table u-table-border u-table-striped u-table-media-phone">
        <tbody>
          <tr>
            <th>預計請假日</th>
            <td>{moment(item.applyDate).format('YYYY-MM-DD')}</td>
          </tr>
          <tr>
          <th>假別</th>
          <td>{leaveTypeList.find(type => type.id === item.leaveItemId).name}</td>
          </tr>
          <tr>
          <th>請假時段</th>
          <td>{moment(item.sDate).format('HH:mm')} ~ {moment(item.eDate).format('HH:mm')}</td>
          </tr>
          <tr>
          <th>假單狀態</th>
          <td>{item.statusString}</td>
          </tr>
          {
            item.status === '1'?
            <tr>
              <th>簽核人</th>
          <td>{item.approveUser.realName}</td>
            </tr>:''
          }
          <tr>
          <th>備註</th>
          <td> <textarea name="notes" id="notes" cols="20" rows="5" disabled style={{resize:'none'}} value={item.notes||''}></textarea> </td>
          </tr>
          <tr>
          <th>操作</th>
          <td>
            {
              item.status === '0' || item.status === 'R' ?
              <button
              type="button"
              className="btn success btn-md"
              onClick={() => {
                this.handleToggleOpenAddWorkTimeBlock(item.sDate, item.id, 'EDIT')
              }}
              >
                <span>編輯</span>
              </button>
              :
              <></>
            }
          </td>
          </tr> 
        </tbody>
      </table>
    </div>
    ))

    return (
    <div className="p-signTime">
      <div className='u-block u-block--fixHeight'>
        <div className="u-title">個人請假記錄
          <a
              href="https://docs.google.com/presentation/d/1bxH4xHa_Lq5Zl3jQmGLsTCMPur-RigAt-jrP5euy_dw/edit?usp=sharing"
              className="u-how-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-question-circle" />
          </a>
        </div>

        <div className="u-search-box">
          <span>{this.state.isPartTime? '' : '剩餘特休時數:'+ (this.state.remainHours - this.state.signingAnnualHours)+ '/'} 可用補休時數:{this.state.compensatoryHours- this.state.signingCompensatoryHours}</span>
          <span className="mobile-hide"style={{ flex: '0 0 0px' }}>狀態：</span>

          <select style={{minWidth:"56px"}} value={leaveStatus} onChange={(e)=>{
              this.setState({
                leaveStatus: e.target.value,
              }, ()=>this.loadRecList());
            }} className="u-form__select">
            <option value="">全部</option>
            <option value="S">送簽</option>
            <option value="1">核准</option>
            <option value="X">作廢</option>
          </select>

          <span className="mobile-hide"style={{ flex: '0 0 0px' }}>假別：</span>

          <select value={leaveTypeId} className="u-form__select" 
                        onChange={(e)=>{this.setState({
                          leaveTypeId: e.target.value,
                        }, ()=>this.loadRecList());}}
                      >
                        <option value="-1">全部</option>
                        {
                          leaveTypeList.filter(leaveType => leaveType.enable).map(leaveType => (
                              <option key={leaveType.id} value={leaveType.id}>{ leaveType.name }</option>
                          ))
                        }
                      </select>
            <button
                type="button"
                className="btn success btn-md"
                onClick={() => {
                    this.handleToggleOpenAddWorkTimeBlock(moment().format('YYYY-MM-DD'), -1, 'ADD')
                }}
                >
                    <span>請假</span>
            </button>

        </div>

        <div className="u-table-responsive">
        <table className="u-table u-table-border u-table-striped u-table-media">
            <thead>
              <tr>
                <th>預計請假日</th>
                <th>假別</th>
                <th>請假時段</th>
                <th>時數</th>
                <th>假單狀態</th>
                <th>簽核人</th>
                <th>備註</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {
                leaveRecList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{moment(item.applyDate).format('YYYY-MM-DD')}</td>
                      <td>{leaveTypeList.find(type => type.id === item.leaveItemId).name}</td>
                      <td>{moment(item.sDate).format('HH:mm')} ~ {moment(item.eDate).format('HH:mm')}</td>
                      <td>{item.leaveHours}</td>
                      <td>{item.statusString}</td>
                      {
                          item.status === '1'? 
                          <td>{item.approveUser.realName}</td>
                          :<td>尚未通過</td>
                        }
                      <td> <textarea name="notes" id="notes" cols="30" rows="5" disabled style={{resize:'none'}} value={item.notes||''}></textarea> </td>
                      <td>

                      {
                          item.fileName ?
                          <div className="row">
                            <div className="col-12 col-pad-12">
                            <button onClick={() => {window.open(item.fileName, "_blank")}}>附件</button> <br/>
                            </div>
                          </div>
                        :''
                      }
                      
                      {
                        item.status === '0' || item.status === 'R' ?
                        <button
                        type="button"
                        className="btn success btn-md"
                        onClick={() => {
                          this.handleToggleOpenAddWorkTimeBlock(item.sDate, item.id, 'EDIT')
                        }}
                        >
                          <span>編輯</span>
                        </button>
                        :
                        <></>
                      }
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
        {
          leaveRecList.length > 0 ? <Slider {...settings}>
          {
            slides
          }
        </Slider>:''
        }

        <div className="u-notice">※無資料和店長確認。</div>
        <div className="pagination-box">
            {pageControl}
        </div>
        <FillLeave 
          isVisible={this.state.isAddWorkTimeOpen} 
          toggleOpen={this.handleToggleOpenAddWorkTimeBlock} 
          targetDate = {this.state.editTargetDate} 
          allStaff={this.state.employees} 
          editTarget={this.state.editTarget}
          allLeaveType={this.state.isPartTime?this.state.leaveTypeList.filter(type=>type.id != 1):this.state.leaveTypeList} 
          saveWorkRecordFunc={this.handleAddStaffWorkRecord}
          targetEventId={this.state.editTargetId}
          onChangeFunc={this.handleOnChangeLeaveRecInput}
          longLeave={this.state.longLeave}
          remainHours = {this.state.remainHours- this.state.signingAnnualHours}
          compensatoryHours = {this.state.compensatoryHours- this.state.signingCompensatoryHours}
        />
      </div>
      
    </div>
    )
  }
}

export default LeaveList